<template>
  <div>
    <modal-dlg :title="`NCS 소양 과목 ${subject._id ? '수정' : '추가'}`">
      <mdb-input icon="chalkboard-teacher" v-model="subject.name" label="단원명" />
      <mdb-input icon="file-alt" v-model="subject.content" label="학습내용" />
      <mdb-input icon="clock" v-model="subject.totalHours" label="학습시간" class="w-20" />
      <div class="text-center">
        <mdb-btn icon="check" class="p-2 px-3" @click="$emit('ok')">확인</mdb-btn>
        <mdb-btn icon="undo" class="p-2 px-3" @click="$emit('cancel')">취소</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import { } from 'mdbvue';
import ModalDlg from '@/components/common/ModalDlg.vue';
export default {
  components: { ModalDlg },
  name: 'CultureSubject',
  props: ['value'],
  data () {
    return {
      subject: this.value
    }
  }
}
</script>
